module.exports = __webpack_public_path__ + "img/visual-01.381ef63c.png";